import React from 'react'
import ReactDOM from 'react-dom'
import App from './app'
import {BASE_URL} from './constants'
import {Provider} from 'react-redux'
import {store, history} from './store'
import {ConnectedRouter} from 'react-router-redux'
import ApiProvider from './apiProvider'
import 'babel-polyfill'
import 'react-table/react-table.css'
import './build/index.min.css'

const Root = () => (
  <Provider store={store}>
    <ApiProvider baseUrl={BASE_URL}>
      <ConnectedRouter history={history}>
        <App />
      </ConnectedRouter>
    </ApiProvider>
  </Provider>
)

ReactDOM.render(<Root />, document.getElementById('root'))



// WEBPACK FOOTER //
// ./src/index.js